import React from 'react';

import { Helmet } from 'react-helmet';
import MUIProvider from '~/contexts/MUIProvider';

import PageHeader from '~/components/Common/Elements/PageHeader';

import DealCrawlerList from './components/DealCrawlerList';

export default function CrawlDealPage() {
  return (
    <MUIProvider>
      <Helmet>
        <title>Deal Crawlers</title>
      </Helmet>

      <PageHeader title="Deal Crawlers" />

      <DealCrawlerList />
    </MUIProvider>
  );
}
